/**
 * Collection FAQ Component
 * Handles read more/less functionality and accordion behavior
 */

class CollectionFaq {
  constructor(container) {
    this.container = container;
    this.descriptionWrapper = container.querySelector('.collection-faq__description');
    this.readMoreBtn = container.querySelector('[data-faq-read-more]');
    this.truncatedText = container.querySelector('[data-faq-desc-truncated]');
    this.fullText = container.querySelector('[data-faq-desc-full]');
    this.faqItems = container.querySelectorAll('[data-faq-item]');
    this.isExpanded = false;
    
    this.init();
  }
  
  init() {
    this.bindEvents();
    // Ensure first item is expanded and visible by default
    this.ensureFirstItemState();
  }
  
  bindEvents() {
    // Read more/less toggle
    if (this.readMoreBtn) {
      this.readMoreBtn.addEventListener('click', this.handleReadMoreClick.bind(this));
    }
    
    // FAQ accordion toggles
    this.faqItems.forEach(item => {
      const toggle = item.querySelector('[data-faq-toggle]');
      if (toggle) {
        toggle.addEventListener('click', (e) => this.handleFaqToggle(e, item));
      }
    });
  }
  
  ensureFirstItemState() {
    const firstItem = this.container.querySelector('[data-faq-first]');
    if (firstItem) {
      firstItem.classList.add('collection-faq__item--expanded');
      firstItem.classList.remove('collection-faq__item--hidden');
      const answer = firstItem.querySelector('[data-faq-answer]');
      const toggle = firstItem.querySelector('[data-faq-toggle]');
      if (answer) {
        answer.hidden = false;
      }
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'true');
      }
    }
  }
  
  handleReadMoreClick(event) {
    event.preventDefault();
    this.isExpanded = !this.isExpanded;
    
    // Toggle description expanded state
    if (this.descriptionWrapper) {
      this.descriptionWrapper.classList.toggle('is-expanded', this.isExpanded);
    }
    
    // Toggle full container expanded state (shows/hides other FAQ items)
    this.container.classList.toggle('is-expanded', this.isExpanded);
    
    // Toggle text visibility
    if (this.truncatedText && this.fullText) {
      this.truncatedText.style.display = this.isExpanded ? 'none' : 'inline';
      this.fullText.style.display = this.isExpanded ? 'inline' : 'none';
    }
    
    // Toggle read more/less text
    const readMoreText = this.readMoreBtn.querySelector('.read-more-text');
    const readLessText = this.readMoreBtn.querySelector('.read-less-text');
    if (readMoreText && readLessText) {
      readMoreText.style.display = this.isExpanded ? 'none' : 'inline';
      readLessText.style.display = this.isExpanded ? 'inline' : 'none';
    }
  }
  
  handleFaqToggle(event, item) {
    event.preventDefault();
    
    const toggle = item.querySelector('[data-faq-toggle]');
    const answer = item.querySelector('[data-faq-answer]');
    const isCurrentlyExpanded = item.classList.contains('collection-faq__item--expanded');
    
    // Close all other items
    this.faqItems.forEach(otherItem => {
      if (otherItem !== item) {
        otherItem.classList.remove('collection-faq__item--expanded');
        const otherToggle = otherItem.querySelector('[data-faq-toggle]');
        const otherAnswer = otherItem.querySelector('[data-faq-answer]');
        if (otherToggle) {
          otherToggle.setAttribute('aria-expanded', 'false');
        }
        if (otherAnswer) {
          otherAnswer.hidden = true;
        }
      }
    });
    
    // Toggle current item
    if (isCurrentlyExpanded) {
      item.classList.remove('collection-faq__item--expanded');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
      if (answer) {
        answer.hidden = true;
      }
    } else {
      item.classList.add('collection-faq__item--expanded');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'true');
      }
      if (answer) {
        answer.hidden = false;
      }
    }
  }
}

// Initialize all Collection FAQ components on page
function initCollectionFaq() {
  const faqContainers = document.querySelectorAll('[data-collection-faq]');
  faqContainers.forEach(container => {
    new CollectionFaq(container);
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionFaq);
} else {
  initCollectionFaq();
}

// Re-initialize on Shopify section load (for theme editor)
document.addEventListener('shopify:section:load', (event) => {
  const faqContainer = event.target.querySelector('[data-collection-faq]');
  if (faqContainer) {
    new CollectionFaq(faqContainer);
  }
});
